import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const calendarMonthsListFn = /* @__PURE__ */ createRecipe('calendar-months-list', {}, [])

const calendarMonthsListVariantMap = {}

const calendarMonthsListVariantKeys = Object.keys(calendarMonthsListVariantMap)

export const calendarMonthsList = /* @__PURE__ */ Object.assign(memo(calendarMonthsListFn.recipeFn), {
  __recipe__: true,
  __name__: 'calendarMonthsList',
  __getCompoundVariantCss__: calendarMonthsListFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: calendarMonthsListVariantKeys,
  variantMap: calendarMonthsListVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, calendarMonthsListVariantKeys)
  },
  getVariantProps: calendarMonthsListFn.getVariantProps,
})